// extracted by mini-css-extract-plugin
export default {"selected":"Music_selected__+4waz"};